module.exports = __webpack_public_path__ + "media/mypage/images/fa/1-ada312d0000c97ee3f8aa5364cb25836.jpg";